module.exports = __webpack_public_path__ + "media/images/flags/16/Yemen-eb4e988b48c1bd1e372206fe166b68dd.png";